import { render, staticRenderFns } from "./FamilyTimeline.vue?vue&type=template&id=7b1dca30&"
import script from "./FamilyTimeline.vue?vue&type=script&lang=js&"
export * from "./FamilyTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports